import { create } from "zustand";

const useReservationQuestionStore = create((set) => ({
    reservationQuestions: [],
    setReservationQuestions: (value) => set({ reservationQuestions: value }),
    updateReservationQuestion: (updatedReservationQuestion) => set((state) => ({
      reservationQuestions: state.reservationQuestions.map((reservationQuestion) => reservationQuestion.id === updatedReservationQuestion.id ? { ...reservationQuestion, ...updatedReservationQuestion } : reservationQuestion)
    })),
    addReservationQuestion: (reservationQuestion) => set((state) => ({
      reservationQuestions: [...state.reservationQuestions, reservationQuestion]
    })),
    removeReservationQuestion: (removedReservationQuestion) => set((state) => ({
      reservationQuestions: state.reservationQuestions.filter((reservationQuestion) => removedReservationQuestion.id !== reservationQuestion.id)
    }))
  })
);

export default useReservationQuestionStore;